import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import './index.scss';
import classNames from 'classnames';
import styled from 'styled-components';

const StyledSelect = styled(Select)`
    .MuiSelect-select {
        padding: 6px 12px;
    }

    .MuiOutlinedInput-notchedOutline {
        border: none;
    }
    .prefix {
        font-size: 12px;
    }
`;

const StyledMenuItem = styled(MenuItem)`
    padding: 6px 12px;

    .prefix {
        font-size: 12px;
    }
`;

const options = [
    {
        value: 'en',
        label: 'English',
        prefix: '🇬🇧',
    },
    // {
    //     value: 'zh-CN',
    //     label: '简体中文',
    //     prefix: '🇨🇳',
    // },
    {
        value: 'ko',
        label: '한국어',
        prefix: 'KR',
    },
];

interface Props {
    customClass?: string;
}

export default function SelectLng(props: Props) {
    const { customClass } = props;
    const { i18n } = useTranslation();
    const [selectedOption, setSelectedOption] = useState(i18n.language);

    useEffect(() => {
        const htmlEl = document.getElementsByTagName('html')[0];
        htmlEl.className = i18n.language;
    }, [i18n.language]);
    return (
        <StyledSelect
            disableUnderline
            className={classNames('select', customClass)}
            value={selectedOption}
            onChange={(e) => {
                const htmlEl = document.getElementsByTagName('html')[0];
                const value = e.target.value as string;
                console.log(value);
                i18n.changeLanguage(value);
                // if (value === 'ru') {
                //     htmlEl.className = 'ru';
                // } else {
                //     htmlEl.className = '';
                // }
                htmlEl.className = value;
                setSelectedOption(value);
            }}
        >
            {options.map((option) => {
                return (
                    <StyledMenuItem
                        value={option.value}
                        disableGutters
                        key={option.value}
                    >
                        <span className="prefix">{option.label}</span>
                        {/* {option.label} */}
                    </StyledMenuItem>
                );
            })}
        </StyledSelect>
    );
}
